/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkerRegisterDto } from '../../models/worker-register-dto';
import { WorkerSessionDto } from '../../models/worker-session-dto';

export interface WorkerControllerRegister$Params {
      body: WorkerRegisterDto
}

export function workerControllerRegister(http: HttpClient, rootUrl: string, params: WorkerControllerRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkerSessionDto>> {
  const rb = new RequestBuilder(rootUrl, workerControllerRegister.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkerSessionDto>;
    })
  );
}

workerControllerRegister.PATH = '/worker/register';
